import { QueryFunctionContext } from "react-query";
import { IItemsInStock, IResponse } from "@drone-parts.garphild.pro/interfaces";
import RestApiQuery from "../../helpers/rest-api-query";

export interface ItemTypeNode {
  id: string;
  title: string;
  children?: ItemTypeNode[];
}

export async function fetchStockItems(context: QueryFunctionContext): Promise<IItemsInStock[]> {
  const [, filters] = context.queryKey as [string, { 
    search?: string; 
    types?: string[] 
  }];
  
  let url = '/api/stock';
  const params = new URLSearchParams();
  
  if (filters.search) {
    params.append('search', filters.search);
  }
  
  if (filters.types && filters.types.length > 0) {
    filters.types.forEach(type => params.append('types[]', type));
  }
  
  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  const result = await RestApiQuery.get<IResponse<IItemsInStock[]>>(url);
  return result?.data || [];
}

export async function fetchItemTypes(): Promise<ItemTypeNode[]> {
  const result = await RestApiQuery.get<IResponse<ItemTypeNode[]>>('/api/stock/item-types');
  return result?.data || [];
}
